import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import TableView from '../../Components/TableView';

// const Wrapper = styled.div``;

const CategoryTable = ({ data }) => {
  const columns = [
    {
      title: 'Category Title',
      dataIndex: 'category__title',
      key: 'category__title',
      render: (value) => value || '-',
      align: 'center',
    },
    {
      title: 'Number of Digests',
      dataIndex: 'count',
      key: 'count',
      render: (value) => value || '-',
      align: 'center',
    },
  ];
  return (
    <>
      <TableView tableColumns={columns} data={data} />
    </>
  );
};

CategoryTable.propTypes = {
  data: PropTypes.object,
};

export default CategoryTable;
